import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconDownload from '@/icons/Download.svg';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ArticleAuthenticityCertificate } from './ArticleAuthenticityCertificate';
import { ArticlePurchaseDate } from './ArticlePurchaseDate';
import { ArticlePurchaseLocation } from './ArticlePurchaseLocation';
import { Item } from './Item';

export const ArticleAuthenticity = () => {
  const { article, proofOfAuthenticityMedia, view } = useArticleContext();
  const { t } = useLingui();

  const proofOfAuthenticity = proofOfAuthenticityMedia?.[0];

  return (
    <Stack gap="0.75rem">
      {!!article.uniqueArticle && view.warranty.fields.authenticityCertificate.shown && (
        <ArticleAuthenticityCertificate mode="sidebar" />
      )}
      {view.warranty.fields.purchaseDate.shown && <ArticlePurchaseDate />}
      {view.warranty.fields.purchaseLocation.shown && <ArticlePurchaseLocation />}
      {view.warranty.fields.proofOfPurchase.shown && (
        <Item
          label={t({
            id: 'article.information.proof-of-authenticity',
            message: 'Proof of authenticity',
          })}
        >
          {proofOfAuthenticity && (
            <Stack row flexWrap="nowrap" gap="0.25rem">
              <InlineText weight="medium" ellipsis>
                {proofOfAuthenticity.originalPath}
              </InlineText>
              <Button
                href={proofOfAuthenticity.url}
                download
                variant="secondary"
                iconOnly
                size="small"
                tooltip={t({ id: 'article.information.download', message: 'Download' })}
              >
                <IconDownload className="text-secondary" />
              </Button>
            </Stack>
          )}
        </Item>
      )}
    </Stack>
  );
};
